;(function (root, $, undefined) {
    'use strict'

    var isMobile = function () {
        return 'ontouchstart' in window
    }

    $(function () {
        var slider = $('div.easingslider')

        $('.event-subscribe-btn').click(function (e) {
            const form = $('.article-form')
            form.addClass('openForm')
            form.scrollTo(300)
        })

        // $(".article-form .wpcf7-form span.event-subscribe-btn:not(.clicked)").click(function(e){
        //   $(this).parents('form').trigger('submit');
        // });

        const docWidth =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth

        if (isMobile && docWidth <= 880) {
            $('nav.nav').on('click', function () {
                $(this).find('ul').toggleClass('opened')
            })
        }

        if (docWidth >= 480) {
            $('.sliderBanner').slick({
                dots: false,
                arrows: false,
                infinite: true,
                speed: 250,
                slidesToShow: 1,
                autoplay: true,
                autoplaySpeed: 4000,
                fade: true,
                cssEase: 'linear',
                lazyLoad: 'ondemand',
            })

            $('.gallery-media-wrapper').slick({
                dots: false,
                arrows: false,
                infinite: true,
                speed: 500,
                slidesToShow: 6,
                slidesToScroll: 6,
                lazyLoad: 'ondemand',
                responsive: [
                    {
                        breakpoint: 960,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        },
                    },
                    {
                        breakpoint: 720,
                        settings: {
                            centerMode: true,
                            centerPadding: '20px',
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: 'unclick',
                    },
                ],
            })

            //  end of slick sliders
        }
    })
})(this, jQuery)
